var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "hwk-page" }, [
    _c("header", { staticClass: "hwk-hero" }, [
      _c("div", { staticClass: "hero-row" }, [
        _c("div", [
          _c("p", { staticClass: "hero-hi" }, [_vm._v("作业")]),
          _c("p", { staticClass: "hero-sub" }, [_vm._v(_vm._s(_vm.subtitle))]),
        ]),
        _c("span", { staticClass: "seg" }, [
          _c(
            "i",
            {
              class: { on: _vm.range === "today" },
              on: {
                click: function ($event) {
                  return _vm.switchRange("today")
                },
              },
            },
            [_vm._v("今天")]
          ),
          _c(
            "i",
            {
              class: { on: _vm.range === "week" },
              on: {
                click: function ($event) {
                  return _vm.switchRange("week")
                },
              },
            },
            [_vm._v("本周")]
          ),
        ]),
      ]),
    ]),
    _c("main", { staticClass: "hwk-body" }, [
      _c("section", { staticClass: "stat-card" }, [
        _c("div", { staticClass: "st-item" }, [
          _c("p", { staticClass: "st-label" }, [_vm._v("待交")]),
          _c("p", { staticClass: "st-num c-amber" }, [
            _vm._v(_vm._s(_vm.stat.todo)),
          ]),
        ]),
        _c("div", { staticClass: "st-item" }, [
          _c("p", { staticClass: "st-label" }, [_vm._v("已交")]),
          _c("p", { staticClass: "st-num c-green" }, [
            _vm._v(_vm._s(_vm.stat.done)),
          ]),
        ]),
        _c("div", { staticClass: "st-item" }, [
          _c("p", { staticClass: "st-label" }, [_vm._v("逾期")]),
          _c("p", { staticClass: "st-num c-red" }, [
            _vm._v(_vm._s(_vm.stat.overdue)),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "filter" },
        _vm._l(_vm.filters, function (f) {
          return _c(
            "span",
            {
              key: f.key,
              staticClass: "filter-item",
              class: { on: _vm.filter === f.key },
              on: {
                click: function ($event) {
                  _vm.filter = f.key
                },
              },
            },
            [
              _vm._v(" " + _vm._s(f.text)),
              f.count ? _c("em", [_vm._v(_vm._s(f.count))]) : _vm._e(),
            ]
          )
        }),
        0
      ),
      _c(
        "div",
        { staticClass: "list" },
        [
          _vm._l(_vm.list, function (it) {
            return _c(
              "div",
              {
                key: it.id,
                staticClass: "item",
                on: {
                  click: function ($event) {
                    return _vm.openItem(it)
                  },
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "it-badge",
                    style: { background: it.meta.bg, color: it.meta.fg },
                  },
                  [_vm._v(" " + _vm._s(it.meta.short) + " ")]
                ),
                _c("div", { staticClass: "it-main" }, [
                  _c("p", { staticClass: "it-title" }, [
                    _vm._v(_vm._s(it.title)),
                  ]),
                  _c("p", { staticClass: "it-note" }, [
                    _vm._v(_vm._s(it.due) + " · " + _vm._s(it.note)),
                  ]),
                ]),
                _c(
                  "span",
                  {
                    staticClass: "it-status",
                    style: {
                      background: it.statusMeta.bg,
                      color: it.statusMeta.fg,
                    },
                  },
                  [_vm._v(" " + _vm._s(it.statusMeta.text) + " ")]
                ),
              ]
            )
          }),
          !_vm.list.length
            ? _c("p", { staticClass: "empty" }, [_vm._v("这一类暂时没有作业")])
            : _vm._e(),
        ],
        2
      ),
      _c("p", { staticClass: "tip" }, [
        _vm._v("演示数据 · 接入作业记录后自动同步"),
      ]),
    ]),
    _vm.toast
      ? _c("p", { staticClass: "toast-tip" }, [_vm._v(_vm._s(_vm.toast))])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }